<template>
  <div class="new-upload" v-show="order.user_order_id">
    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" to="/orders">订单管理</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/orders/ordering/waitting-for-upload/' + order.user_order_id">资料上传</router-link>
      <div class="bread-arrow">&gt;</div>
      <a class="bread-item">资料详情</a>
    </div>

    <div class="upload-container">
      <div class="fliggy-order-info-bar-box" v-if="order.ota_info">
        <fliggy-order-info-bar :ota-info="order.ota_info"></fliggy-order-info-bar>
      </div>

      <div class="upload-header fixed-header" v-show="fixedHeader">
        <div class="applicant-header">

          <!-- 返回 -->
          <div class="back-btn" @click="back">
            <img src="../assets/imgs/application/arrow-back.png">
            <span>返回</span>
          </div>

          <div class="applicant-name" v-text="applicant.applicant_name"></div>
          <div class="identity" v-if="applicant.material">{{applicant.material.identity_id == 5 ? '通用身份' : maps.identity[applicant.material.identity_id]}}</div>
          <div class="fill-remaining-space"></div>
          <el-button type="primary" class="common-button" @click="save()">确定</el-button>
        </div>
      </div>

      <!-- 申请人头 -->
      <div class="upload-header">
        <div class="applicant-header">

          <!-- 返回 -->
          <div class="back-btn" @click="back">
            <img src="../assets/imgs/application/arrow-back.png">
            <span>返回</span>
          </div>

          <div class="applicant-name" v-text="applicant.applicant_name"></div>
          <div class="identity" v-if="applicant.material">{{applicant.material.identity_id == 5 ? '通用身份' : maps.identity[applicant.material.identity_id]}}</div>
          <div class="fill-remaining-space"></div>
          <el-button type="primary" class="common-button" @click="save()">确定</el-button>
        </div>
      </div>

      <div class="upload-main">
        <fliggy-material :applicant="applicant"></fliggy-material>

        <!-- 必备资料 -->
        <div v-if="applicant.material && applicant.material.material_required.length">
          <div class="type-title">必备资料</div>
          <div class="body">

            <!-- 证件照 -->
            <upload-id-photo v-if="applicant.id_photo" :order-id-photo="order.id_photo" :id-photo="applicant.id_photo" :applicant="applicant" :order="order"
              @reviewImage="openImageReview" @saveUploadInputId="saveUploadInputId"></upload-id-photo>

            <!-- 循环处理所有电子资料 -->
            <div class="upload-panel" v-for="material in applicant.material.material_required" :key="material.elec_id" v-if="material.attr === consts.material.TYPE.elec_0">

              <!-- 表格 -->
              <upload-table
                v-if="material.pattern === consts.material.PATTERN.table_4"
                :order="order"
                :applicant="applicant"
                :material="material"
                :is-required="true"
                :is-reupload="true"
              ></upload-table>

              <!-- 身份证 -->
              <upload-id-card id="id-required" v-if="material.pattern === consts.material.PATTERN.idCardOCR_1" :id-card="material" :applicant="applicant"
                @reviewImage="openImageReview" :order="order"
                @saveUploadInputId="saveUploadInputId" @updateOrder="getOrder"></upload-id-card>

              <!-- 护照 -->
              <upload-passport id="passport-required" v-if="material.pattern === consts.material.PATTERN.passortOCR_2" :passport="material" :applicant="applicant"
                @reviewImage="openImageReview" :order="order"
                @saveUploadInputId="saveUploadInputId" @updateOrder="getOrder"></upload-passport>

              <!-- 婚姻证明 -->
              <upload-marital v-if="material.pattern === consts.material.PATTERN.marriageCertificate_3" :marital="material" :applicant="applicant"
                @reviewImage="openImageReview" :order="order"></upload-marital>

              <!-- 单页资料 -->
              <upload-single-page :single-page="material" :applicant="applicant" @reviewImage="openImageReview" :is-optional="false" :order="order"
                v-if="material.pattern === consts.material.PATTERN.defaul_0 && material.style === consts.material.STYLE.singlePage_0"></upload-single-page>

              <!-- 多页资料 -->
              <upload-multi-page :multi-page="material" :applicant="applicant" @reviewImage="openImageReview" :is-optional="false" :order="order"
                v-if="material.pattern === consts.material.PATTERN.defaul_0 && material.style === consts.material.STYLE.multiPage_1"></upload-multi-page>
            </div>

            <!-- 最后一个资料后面的高度和其他不一样，直接用一个空div填充最简单 -->
            <div class="empty-white-more-space"></div>
          </div>
        </div>

        <!-- 辅助资料 -->
        <div v-if="optionalElecMaterialShouldShow">
          <div class="type-title">辅助资料</div>
          <div class="body">

            <!-- 循环处理所有电子资料 -->
            <div class="upload-panel" v-for="material in applicant.material.material_optional" :key="material.elec_id" v-if="material.attr === consts.material.TYPE.elec_0">
              <!-- 表格 -->
              <upload-table
                v-if="material.pattern === consts.material.PATTERN.table_4"
                :order="order"
                :applicant="applicant"
                :material="material"
                :is-optional="true"
              ></upload-table>

              <!-- 身份证 -->
              <upload-id-card id="id-optional" v-if="material.pattern === consts.material.PATTERN.idCardOCR_1" :id-card="material" :applicant="applicant"
                @reviewImage="openImageReview" :order="order"
                @saveUploadInputId="saveUploadInputId" @updateOrder="getOrder"></upload-id-card>

              <!-- 护照 -->
              <upload-passport id="passport-optional" v-if="material.pattern === consts.material.PATTERN.passortOCR_2" :passport="material" :applicant="applicant"
                @reviewImage="openImageReview" :order="order"
                @saveUploadInputId="saveUploadInputId" @updateOrder="getOrder"></upload-passport>

              <!-- 婚姻证明 -->
              <upload-marital v-if="material.pattern === consts.material.PATTERN.marriageCertificate_3" :marital="material" :applicant="applicant"
                @reviewImage="openImageReview" :order="order"></upload-marital>

              <!-- 单页资料 -->
              <upload-single-page :single-page="material" :applicant="applicant" @reviewImage="openImageReview" :is-optional="true" :order="order"
                v-if="material.pattern === consts.material.PATTERN.defaul_0 && material.style === consts.material.STYLE.singlePage_0"></upload-single-page>

              <!-- 多页资料 -->
              <upload-multi-page :multi-page="material" :applicant="applicant" @reviewImage="openImageReview" :is-optional="true" :order="order"
                v-if="material.pattern === consts.material.PATTERN.defaul_0 && material.style === consts.material.STYLE.multiPage_1"></upload-multi-page>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog class="review-box" title="图片预览" v-model="imageReviewDialog.open">
      <img :src="imageReviewDialog.src">
    </el-dialog>
  </div>
</template>

<script>
import uploadService from '../services/upload-service';
import materialConstants from '../constants/material-constants';
import globalData from '../libs/global-data';
import Http from '../libs/http';

import { APPLICANT_IDENTITY_MAP } from '../maps/applicant-maps';

import UploadIdPhoto from '../components/upload/upload-id-photo';
import UploadIdCard from '../components/upload/upload-id-card';
import UploadMarital from '../components/upload/upload-marital-material';
import UploadPassport from '../components/upload/upload-passport';
import UploadSinglePage from '../components/upload/upload-single-page-material';
import UploadMultiPage from '../components/upload/upload-multi-page-material';
import UploadTable from '../components/upload/upload-table';


import IdcardPassportInfoModal from '../components/common/modals/idcard-passport-info-modal/idcard-passport-info-modal';
import FliggyOrderInfoBar from '@/components/ota/fliggy-order-info-bar.vue';
import FliggyMaterial from '../components/upload/ota/fliggy-material.vue';

export default {
  name: 'upload',
  components: {
    FliggyOrderInfoBar,
    UploadIdPhoto,
    UploadIdCard,
    UploadMarital,
    UploadPassport,
    UploadSinglePage,
    UploadMultiPage,
    IdcardPassportInfoModal,
    UploadTable,
    FliggyMaterial,
  },
  data() {
    return {
      order: {},
      applicant: {},
      imageReviewDialog: {
        open: false,
        src: '',
      },
      fixedHeader: false,
      params: {
        applicantId: +this.$route.params.aid,
        orderId: +this.$route.params.oid,
      },
      consts: {
        material: materialConstants,
      },
      maps: {
        identity: APPLICANT_IDENTITY_MAP,
      },
      infoVisible: false,
      infoType: '',
      info: {},
      currentMaterial: {},
      currentInputId: '',
      infoReadOnly: false,
    };
  },
  computed: {

    // 只有可选的资料中的电子资料有才显示
    optionalElecMaterialShouldShow() {
      if (this.applicant.material) {
        return this.applicant.material.material_optional.filter(({ attr }) => attr === materialConstants.TYPE.elec_0).length > 0;
      }
    },
  },
  methods: {

    // 打开图片预览
    openImageReview(imageSrc) {
      this.imageReviewDialog.open = true;
      this.imageReviewDialog.src = imageSrc;
    },

    // 获取当前申请人，如果没有获取到，则直接跳转到之前的页面
    getApplicantOrRedirect() {
      // 获取当前申请人
      this.applicant = uploadService.getApplicantInOrderByApplicantId(this.order, this.params.applicantId);
      // 将订单号设置在申请人上面方便传递
      this.applicant.user_order_id = this.order.user_order_id;

      // 如果没有找到当前申请人
      if (!this.applicant.order_applicant_id) {
        return this.$router.replace({
          name: 'waittingForUpload',
          params: {
            oid: +this.$route.params.oid,
          },
        });
      }
    },

    // 获取订单
    getOrder() {
      Http.post('/order_query', { user_order_id: this.params.orderId }).then((data) => {
        this.order = data;

        // 获取申请人
        this.getApplicantOrRedirect();

        // 初始化申请人的电子资料
        uploadService.initApplicantElecMaterialDataForUpload(this.applicant);

        // 初始化特殊字段值
        uploadService.initSpecialAttrValue(this.applicant);
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    back() {
      MtaH5.clickStat('uploadconfirm');
      history.back();
    },

    // 返回
    save() {
      if (!this.applicant.order_applicant_id) return;
      const idcardInfoRequired = this.applicant.material.material_required.filter(material => material.pattern === this.consts.material.PATTERN.idCardOCR_1).pop();
      const passportInfoRequired = this.applicant.material.material_required.filter(material => material.pattern === this.consts.material.PATTERN.passortOCR_2).pop();
      const idcardInfoOptional = this.applicant.material.material_optional.filter(material => material.pattern === this.consts.material.PATTERN.idCardOCR_1).pop();
      const passportInfoOptional = this.applicant.material.material_optional.filter(material => material.pattern === this.consts.material.PATTERN.idCardOCR_1).pop();

      const idcardaNotConfirmRequired = idcardInfoRequired && idcardInfoRequired.upload && idcardInfoRequired.upload[0] && idcardInfoRequired.upload[0].elec_status && idcardInfoRequired.upload[0].elec_status === 1;
      const idcardbNotConfirmRequired = idcardInfoRequired && idcardInfoRequired.upload && idcardInfoRequired.upload[1] && idcardInfoRequired.upload[1].elec_status && idcardInfoRequired.upload[1].elec_status === 1;
      const passportNotConfirmRequired = passportInfoRequired && passportInfoRequired.upload && passportInfoRequired.upload[0] && passportInfoRequired.upload[0].elec_status && passportInfoRequired.upload[0].elec_status === 1;
      const idcardaNotConfirmOptional = idcardInfoOptional && idcardInfoOptional.upload && idcardInfoOptional.upload[0] && idcardInfoOptional.upload[0].elec_status && idcardInfoOptional.upload[0].elec_status === 1;
      const idcardbNotConfirmOptional = idcardInfoOptional && idcardInfoOptional.upload && idcardInfoOptional.upload[1] && idcardInfoOptional.upload[1].elec_status && idcardInfoOptional.upload[1].elec_status === 1;
      const passportNotConfirmOptional = passportInfoOptional && passportInfoOptional.upload && passportInfoOptional.upload[0] && passportInfoOptional.upload[0].elec_status && passportInfoOptional.upload[0].elec_status === 1;

      const handlerScrollTo = (element) => {
        this.$scrollTo(element);
        this.$message({
          message: '请确认并保存证件识别信息',
          type: 'warning',
        });
      };

      if (passportInfoRequired && passportNotConfirmRequired) {
        return handlerScrollTo('#passport-required');
      }
      if (idcardInfoRequired && (idcardaNotConfirmRequired || idcardbNotConfirmRequired)) {
        return handlerScrollTo('#id-required');
      }
      if (passportInfoOptional && passportNotConfirmOptional) {
        return handlerScrollTo('#passport-optional');
      }
      if (idcardInfoOptional && (idcardaNotConfirmOptional || idcardbNotConfirmOptional)) {
        return handlerScrollTo('#id-optional');
      }
      this.$router.replace({ name: 'waittingForUpload', params: { oid: this.order.user_order_id }, query: { go_next_step: true } });
    },

    // 重新调起文件选择弹框
    chooseFileAgain() {
      if (this.currentInputId) {
        const id = `#${this.currentInputId}`;
        const selector = document.querySelector(id);
        selector.click();
        this.currentInputId = '';
      }
    },
    // 保存当前上传input id
    saveUploadInputId(id) {
      this.currentInputId = id;
    },
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.fixedHeader = window.scrollY > 120;
    });
  },
  created() {
    // 申请表流程控制处理
    globalData.fromUpload = true;

    // 查询订单
    this.getOrder();
  },
  beforeDestroy() {
    uploadService.removeApplicantElecMaterialEmptyUploadItem(this.applicant);
  },
};
</script>

<style lang="less">

// 这里的样式在reupload也会用到
  .review-box {
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
      }
    }
  }
</style>


<style scoped lang='less'>
@import '../assets/less/variable';
.new-upload {
  line-height: 1;
  width: 1000px;
  margin: 0 auto 60px auto;
  .bread {
    line-height: inherit;
  }
  .upload-container {
    background-color: @bg;
    box-shadow: 0 0 4px #edeef0;
    .fliggy-order-info-bar-box{
      background: #fff;
      padding: 20px 24px 0px 24px;
    }
    .upload-header {
      transition: all .5s;
      &.fixed-header {
        background-color: @lightGray;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 222;
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }
    .applicant-header {
      height: 68px;
      display: flex;
      align-items: center;
      padding: 0 30px;
      width: 1000px;
      background-color: #fff;
      div.back-btn {
        cursor: pointer;
        display: flex;
        align-items: center;
        &:hover {
          opacity: .8;
        }
        img {
          width: 8px;
          height: 14px;
          margin-right: 10px;
        }
        span {
          font-size: 14px;
          color: @main;
        }
      }
      .applicant-name {
        font-weight: bold;
        font-size: 20px;
        color: @text-dark;
        margin-left: 40px;
        max-width:560px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .identity {
        color: @text-sliver;
        font-size: 16px;
        margin-left: 30px;
      }
      .common-button {
        width: 134px;
        height: 34px;
      }
    }
    .upload-main {
      .type-title {
        height: 50px;
        padding: 0 30px;
        display: flex;
        align-items: center;
        font-size: 18px;
        color: @main;
        background-color: @blue-bg;
        font-weight: 600;
      }
      .upload-panel+ .upload-panel {
        margin-top: 10px;
      }
      .empty-white-more-space {
        width: 100%;
        height: 10px;
        background-color: @bg;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Upload.vue